import { PopupContainer } from "components";
import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState
} from "react";
import { v4 } from "uuid";

const PopupContext = createContext({});

const PupupProvider = ({ children }) => {
  const [messages, setMessages] = useState([]);

  const addPopup = useCallback(({ type, title, description }) => {
    const id = v4();

    const popup = {
      id,
      type,
      title,
      description
    };

    setMessages(state => [...state, popup]);
  }, []);

  const removePopup = useCallback(id => {
    setMessages(state => state.filter(message => id !== message.id));
  }, []);

  const popupContextValue = useMemo(
    () => ({ addPopup, removePopup }),
    [addPopup, removePopup]
  );

  return (
    <PopupContext.Provider value={popupContextValue}>
      {children}
      <PopupContainer messages={messages} />
    </PopupContext.Provider>
  );
};

const usePopup = () => {
  const context = useContext(PopupContext);
  return context;
};

export { PupupProvider, usePopup };
